import React from 'react';
import { Link } from 'react-router';
import { Checkbox, Dialog, label, Radio, RadioGroup, Button } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemCongChuc, RowItemSearchCongChucSoNoiVu} from './datatable/list';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Danhmuc } from 'api';
import { header } from 'constants/table';
import 'react-select/dist/react-select.css';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";
import {CheckPermission} from 'modules/login/CheckPermission';
import {DropDown, Input, DropDownTreeSelectOneElement, TextArea, DropDownTreeMultipleSelect} from 'components/tt-forms/common';
import {MasterLayout} from 'layout';
import {ShowIf} from 'components/utils';
import { InputTuKhoa } from 'modules/reception/form-timkiem';

class CongChuc extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isSubmit: false,
      data: [],
      DataSelectCoQuanQuanLy: [],
      DataSelectChucVu: [],
      DataSelectVaiTro: [],
      DataSelectVaiTrotheoDV: [],
      DataTrangThaiThayDoi: [],
      vaiTroId: '',
      vaiTroIdS: '',
      donViTrucThuocList: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      pageDataSNV: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      popupChonDonVi: false,
      addType: 0,
      hoVaTen: '',
      dienThoai: '',
      email: '',
      gender: 'male',
      coQuanQuanLyID: null,
      chucVu: '',
      nguoiDungActive: false,
      nguoiDungHinhDaiDien: '',
      nguoiDungVaitrosID: [],
      nguoiDungMatKhau: '',
      nguoiDungID: '',
      noiCapCMND: '',
      tableLoading: false,
      buttonLoading: false,
      donViTrucThuocId: '',
      searchLoading: false,
      tuKhoa:'',
      nhomVaiTroId:'',
      search: false,
      congChucId: '',
      chonDonViId: '',
      chonDonViText: '',
      validateDonVi: true,
      chuyenVienNhapLieu: false,
      chuyenVienNhapLieus: false,
      traCuuDonToCao: false,
      boSungThongTin: false,
      congChucThayDoi: '',
      lyDoThayDoi: '',
      emailNguoiDungCu: '',
      listCongChucSNV: [],
      congChucSoNoiVu: '',
      tuKhoaSoNV: '',
      popUpSoNoiVu: false,
      loadingSNV: false,
      timKiemNangCao: false,
      coQuanQuanLyFilter: [],
      capCoQuanQuanLyFilter: [],
      coQuanQuanLyList: [],
      capCoQuanQuanLyList: [],
      getVaiTroInfo : ''
    };
  }

  componentDidMount() {
    this.getListData();
    this.getListCV();
    this.getListCQQL();
    this.getListVT();
    this.getCoQuanQuanLy();
    this.getCapCoQuanQuanLy();
    this.getTrangThaiThayDoi();
    this.getListVTtheoDonVi();
    if (window.debug) {
      console.log('category/CongChuc');
    }
  }

  getCoQuanQuanLy() {
    let params = {};
    Danhmuc.actions.getCoQuanQuanLyTimKiem.request(null, params).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({coQuanQuanLyList: res.data._embedded.coQuanQuanLies});
      }
    });
  }

  getCapCoQuanQuanLy() {
    Danhmuc.actions.getCapCoQuanQuanLyTimKiem.request().then(res => {
      if (res.data && res.data._embedded) {
        this.setState({capCoQuanQuanLyList: res.data._embedded.capCoQuanQuanLies});
      }
    });
  }
  handleSearch(e) {
    e.preventDefault();
    this.setState({
      search: true,
      pageData : {
        number: 0,
        size: 10,
        totalElements: 0
      }
    }, () => {
      this.getListData(true);
    });
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      chuyenviennhaplieu: this.state.chuyenVienNhapLieus,
      traCuuDonToCao: this.state.traCuuDonToCao,
      boSungThongTin: this.state.boSungThongTin,
      sort: 'ngaySua,desc'
    }
    if(this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa.trim();
    }
    if (this.state.timKiemNangCao) {
      if (this.state.vaiTroIdS) {
        params.nhomVaiTroId = this.state.vaiTroIdS;
      }
      if (this.state.capCoQuanQuanLyFilter.length) {
        let ids = [];
        this.state.capCoQuanQuanLyFilter.map(item => {
          ids.push(item.value);
        });
        params.listCapCoQuanQuanLys = ids.join();
      }
      if (this.state.coQuanQuanLyFilter.length) {
        let ids2 = [];
        this.state.coQuanQuanLyFilter.map(item => {
          ids2.push(item.value);
        });
        params.listCoQuanQuanLys = ids2.join();
      }
    }
    Danhmuc.actions.getCongChuc.request(null, params).then(res => {
      if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.congChucs,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  getTrangThaiThayDoi() {
    Danhmuc.actions.getTrangThaiThayDoiNguoiDung.request().then(res => {
      if (res.data) {
        this.setState({DataTrangThaiThayDoi: res.data});
      }
    });
  }

  getListCQQL() {
    Danhmuc.actions.getListCoQuan.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          DataSelectCoQuanQuanLy: res.data._embedded.coQuanQuanLies
        });
      }
    });
  }

  getDonViTrucThuoc(id) {
    if (id) {
      Danhmuc.actions.getDonViTrucThuoc.request(null, {cha: id}).then(res => {
        if (res.data && res.data._embedded) {
          this.setState({
            donViTrucThuocList: res.data._embedded.coQuanQuanLies
          });
        } else {
          this.setState({
            donViTrucThuocList: []
          });
        }
      });
    } else {
      this.setState({
        donViTrucThuocList: []
      });
    }
  }

  getListCV() {
    this.props.danhMuc.getListChucVu().then(res => {
      if (res.data._embedded) {
        this.setState({
          DataSelectChucVu: res.data._embedded.chucVus
        });
      }
    });
  }

  getListVT() {
    this.props.danhMuc.getListVaiTro().then(res => {
      if (res.data._embedded) {
        this.setState({
          DataSelectVaiTro: res.data._embedded.vaiTroes
        });
      }
    });
  }

  getListVTtheoDonVi() {
    this.props.danhMuc.getListVaiTrotheoDV().then(res => {
      if (res && res.data && res.data._embedded) {
        this.setState({DataSelectVaiTrotheoDV: res.data._embedded.vaiTroes});
      }
    });
  }

  handlePageClick(page) {
    if (this.state.popUpSoNoiVu) {
      this.state.pageDataSNV.number = page.selected;
      this.timKiemCongChucSNV();
    } else {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }

  handleChangePageSize(size) {
    if (this.state.popUpSoNoiVu) {
      this.state.pageDataSNV.size = size;
      this.state.pageDataSNV.number = 0;
      this.timKiemCongChucSNV();
    } else {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }

  createCategory() {
    if(this.validateSubmitForm()){
      let params = {
        hoVaTen: this.state.hoVaTen.trim(),
        dienThoai: this.state.dienThoai.trim(),
        gioiTinh: this.state.gender == 'male' ? true : false,
        chucVu: this.state.chucVu,
        nguoiDung : {
          email: this.state.email.trim(),
          active: true,
          traCuuDonToCao: this.state.traCuuDonToCao,
          boSungThongTin: this.state.boSungThongTin,
          hinhDaiDien: this.state.nguoiDungHinhDaiDien,
          vaiTroMacDinh: {id: this.state.vaiTroId},
          vaiTros: [
            {id: this.state.vaiTroId}
          ],
          matKhau: this.state.nguoiDungMatKhau
        },
        coQuanQuanLy: {id: this.state.chonDonViId},
      };

      if (this.state.vaiTroId == 3) {
        params.nguoiDung.chuyenVienNhapLieu = this.state.chuyenVienNhapLieu;
      }

      if (this.state.congChucThayDoi) {
        params.nguoiDung.congChucThayDoi = this.state.congChucThayDoi;
      }
      if (this.state.lyDoThayDoi) {
        params.nguoiDung.lyDoThayDoi = this.state.lyDoThayDoi;
      }
      if (this.state.emailNguoiDungCu) {
        params.nguoiDung.emailNguoiDungCu = this.state.emailNguoiDungCu;
      }
      if (this.state.congChucSoNoiVu) {
        params.soNoiVuId = this.state.congChucSoNoiVu.congChucSoNoiVuId;
      }

      this.setState({buttonLoading: true});
      if (this.state.congChucId) {
        params.nguoiDung.id = this.state.nguoiDungID;
        Danhmuc.actions.updateCongChuc.request({id: this.state.congChucId}, params).then(res => {
          this.getListData();
          this.callDialog('popupAddCategory', false);
          Toastr(msg.updateCategorySucess,'success');
          this.setState({buttonLoading: false,congChucSoNoiVu:''});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false,congChucSoNoiVu:''});
          }
        });
      } else {
        Danhmuc.actions.postCongChuc.request(null, params).then(res => {
          this.getListData();
          this.callDialog('popupAddCategory', false);
          Toastr(msg.addCategorySucess,'success');
          this.setState({buttonLoading: false,congChucSoNoiVu:''});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false,congChucSoNoiVu:''});
          }
        });
      }
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });

    this.state.validateDonVi = this.state.chonDonViId != '';
    this.setState({...this.state});
    if (pass) {
      pass = this.state.validateDonVi;
    }

    return pass;
  }

  componentWillUnmount() {
    //
  }

  handleDelete(congChucId) {
    if(congChucId){
      this.setState({buttonLoading: true});
      this.props.danhMuc.deleteCongChuc({id: congChucId}).then(res => {
        this.getListData();
        Toastr(msg.delCategorySucess,'success');
        this.setState({buttonLoading: false});
      }).catch(error => {
            if (error.response) {
              Toastr(error.response.data.errors[0].detail,'error');
              this.setState({buttonLoading: false});
            }
      });
    }
  }

  onChange(name,e) {
    let newState = {...this.state};
    if (name == 'coQuanQuanLyFilter') {
      newState.coQuanQuanLyFilter = e;
    } else if (name == 'capCoQuanQuanLyFilter') {
      newState.capCoQuanQuanLyFilter = e;
    } else {
      newState[name] = e.target.value;
    }
    this.setState({...newState});

    if (name == 'coQuanQuanLyID') {
      this.getDonViTrucThuoc(e.target.value);
    }
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  callDialog(name, status) {
    this.state[name] = status;
    if (!status && name=='popupAddCategory') {
      //
      this.state.chonDonViId = '';
      this.state.chonDonViText = '';
    }
    this.setState({...this.state});
  }

  openAddNewCategory() {
    this.setState({isSubmit: false});
    this.callDialog('popupAddCategory', true);
    this.setState({
      addType:0,
      hoVaTen: '',
      dienThoai: '',
      email: '',
      gender: 'male',
      coQuanQuanLyID: null,
      coQuanQuanLyCMNDId: '',
      chucVu: '',
      nguoiDungActive: false,
      nguoiDungHinhDaiDien: '',
      nguoiDungVaitrosID: [],
      nguoiDungMatKhau: '' ,
      congChucId: 0,
      donViTrucThuocId:'',
      donViTrucThuocList: [],
      validateDonVi: true,
      congChucThayDoi: '',
      lyDoThayDoi: '',
      emailNguoiDungCu: '',
      congChucSoNoiVu: '',
      getVaiTroInfo: '',
      popUpSoNoiVu: false,
    });
    this.timKiemCongChucSNV();
  }

  openUpdateCategory(item) {
    this.setState({isSubmit: false});
    this.callDialog('popupAddCategory', true);
    let getVaiTro = '';
    if (item.donViCongChuc && item.donViCongChuc.cha) {
      this.state.chonDonViId = item.donViCongChuc.coQuanQuanLyId;
      this.state.chonDonViText = `${item.donViCongChuc.ten} thuộc ${item.donViCongChuc.cha.ten}`;
    } else if (item.donViCongChuc) {
      this.state.chonDonViId = item.donViCongChuc.coQuanQuanLyId;
      this.state.chonDonViText = item.donViCongChuc.ten;
    }
    if (item.soNoiVuId) {
      this.state.congChucSoNoiVu = {congChucSoNoiVuId: item.soNoiVuId, hoVaTen: 'Đã liên kết'};
    } else {
      this.state.congChucSoNoiVu = '';
    }
    if(item && item.nguoiDungCongChuc && item.nguoiDungCongChuc.vaiTroMacDinhInfo && item.nguoiDungCongChuc.vaiTroMacDinhInfo.listCoQuanQuanLy && item.nguoiDungCongChuc.vaiTroMacDinhInfo.listCoQuanQuanLy.length === 0) {
      getVaiTro = item.nguoiDungCongChuc.vaiTroMacDinhInfo.ten;
    }

    this.setState({
      addType:2,
      congChucId: item.congChucId,
      hoVaTen: item.hoVaTen,
      dienThoai: item.dienThoai,
      email: item.nguoiDungCongChuc.email,
      gender: item.gioiTinh ? 'male' : 'female',
      chucVu: item.chucVu || '',
      nguoiDungActive: item.nguoiDungCongChuc.active,
      nguoiDungHinhDaiDien: item.nguoiDungCongChuc.hinhDaiDien,
      nguoiDungID: item.nguoiDungCongChuc.nguoiDungId,
      nguoiDungMatKhau: '' ,
      chonDonViId: this.state.chonDonViId,
      chonDonViText: this.state.chonDonViText,
      traCuuDonToCao: item.nguoiDungCongChuc.traCuuDonToCao,
      boSungThongTin: item.nguoiDungCongChuc.boSungThongTin,
      donViTrucThuocId: '',
      chuyenVienNhapLieu: item.nguoiDungCongChuc.chuyenVienNhapLieu,
      coQuanQuanLyID: null,
      donViTrucThuocList: [],
      validateDonVi: true,
      vaiTroId : item.nguoiDungCongChuc && item.nguoiDungCongChuc.vaiTroNguoiDung ? item.nguoiDungCongChuc.vaiTroNguoiDung[0].vaiTroId : '',
      congChucThayDoi: item.nguoiDungCongChuc.congChucThayDoiInfo ? item.nguoiDungCongChuc.congChucThayDoiInfo.giaTri : '',
      lyDoThayDoi: item.nguoiDungCongChuc.lyDoThayDoi || '',
      emailNguoiDungCu: item.nguoiDungCongChuc.emailNguoiDungCu || '',
      getVaiTroInfo: getVaiTro
    });
    this.timKiemCongChucSNV();
  }
  chonDonVi() {
    if (this.state.donViTrucThuocId) {
      this.state.chonDonViId = this.state.donViTrucThuocId;
      this.state.donViTrucThuocList.map((item) => {
        if (item.coQuanQuanLyId == this.state.donViTrucThuocId) {
          this.state.chonDonViText = item.ten + ' thuộc ';
        }
      });
      this.state.DataSelectCoQuanQuanLy.map((item) => {
        if (item.coQuanQuanLyId == this.state.coQuanQuanLyID) {
          this.state.chonDonViText += item.ten;
        }
      });
    } else if (this.state.coQuanQuanLyID) {
      this.state.chonDonViId = this.state.coQuanQuanLyID;
      this.state.DataSelectCoQuanQuanLy.map((item) => {
        if (item.coQuanQuanLyId == this.state.coQuanQuanLyID) {
          this.state.chonDonViText = item.ten;
        }
      });
    }
    this.callDialog('popupChonDonVi', false);
    this.state.validateDonVi = true;
    this.setState({...this.state});
  }

  changeCheckbox(name, e) {
    this.setState({[name]: e.target.checked});
  }

  timKiemCongChucSNV() {
    let params = {
      page: this.state.pageDataSNV.number,
      size: this.state.pageDataSNV.size,
      tuKhoa: this.state.tuKhoaSoNV.trim()
    }
    this.setState({loadingSNV: true});
    Danhmuc.actions.getCongChucSoNoiVu.request(null, params).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({
          listCongChucSNV: res.data._embedded.congChucSoNoiVus,
          pageDataSNV: res.data.page
        });
      } else {
        this.setState({listCongChucSNV: [],
          pageDataSNV: {
            number: 0,
            size: 10,
            totalElements: 0
          }
        })
      }
      this.setState({loadingSNV: false});
    }).catch(e => {
      this.setState({loadingSNV: false});
    });
  }
  toggleSearch(status) {
    if (status) {
      this.setState({timKiemNangCao : true});
    } else {
      this.setState({timKiemNangCao : false});
    }
  }

  handleSelectSNV(item) {
    this.state.congChucSoNoiVu = item;
    this.state.email = item.email;
    this.state.hoVaTen = item.hoVaTen;
    this.state.chucVu = item.tenChucVu;
    this.callDialog('popUpSoNoiVu', false);
  }

  render() {
    const adminId = 1;
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Danh sách người dùng</p>
            </div>
            <div className="right-content">
              {
                CheckPermission('CONGCHUC_THEM') ?
                  <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
                : null
              }
            </div>
          </div>
          <div className="bottom-content">
            <div className={ this.state.timKiemNangCao ? 'search-container super-search' : 'search-container' }>
              <form className="search-form" onSubmit={ this.handleSearch.bind(this) }>
                <InputTuKhoa value={this.state.tuKhoa} onChange={ this.onChange.bind(this, 'tuKhoa') } placeholderText="Nhập từ khóa để tìm kiếm..." />
                <div className="btn-wrap">
                  <Button className={`btn-green tt-search`} text="Tìm kiếm" type="submit" disabled={ this.state.searching ? 'disabled' : '' } />
                </div>
                {
                  this.state.timKiemNangCao &&
                    <div className="btn-wrap">
                      <Link style={{marginTop: '10px'}} className={ this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search" } onClick={ this.toggleSearch.bind(this, false) }><i className="tt tt-delete"></i>Hủy tìm kiếm nâng cao</Link>
                    </div>
                }
                {
                  this.state.timKiemNangCao &&
                    <div className='clear-left display-flex'>
                      <DropDown className="col-25 mb0-18" label="Nhóm vai trò" bindValidator={this} channel="formTaoDon" require={false} options={this.state.DataSelectVaiTro} placeholder keyName="vaiTroId" valueName="ten" selectedValue={this.state.vaiTroIdS} onChange={this.onChange.bind(this, 'vaiTroIdS')}/>
                      <DropDownTreeMultipleSelect className="col-25 tree-selected" label="Cấp cơ quan quản lý" dataOptions={this.state.capCoQuanQuanLyList} dataSelected={this.state.capCoQuanQuanLyFilter} onChange={this.onChange.bind(this, 'capCoQuanQuanLyFilter')} selectAllChildren={false} propertyChildren='capCoQuanQuanLyCha' propertyParent='capCoQuanQuanLyId'/>
                      <DropDownTreeMultipleSelect className="col-25 tree-selected" label="Cơ quan quản lý" dataOptions={this.state.coQuanQuanLyList} dataSelected={this.state.coQuanQuanLyFilter} onChange={this.onChange.bind(this, 'coQuanQuanLyFilter')} selectAllChildren={false} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId'/>
                      <Checkbox className="cb-cvnl pt-position-button tree-selected pt-large" name="chuyenVienNhapLieus" checked={this.state.chuyenVienNhapLieus ? true : false} onChange={this.changeCheckbox.bind(this,'chuyenVienNhapLieus')}>
                        <span className="span-checkbox span-position-label">Chuyên viên nhập liệu</span>
                      </Checkbox>
                    </div>
                }

              </form>
              <Link className="rearch-text" onClick={ this.toggleSearch.bind(this, true) }><i className="tt tt-super-search"></i>Tìm kiếm nâng cao</Link>
            </div>
            <DataTable
              header = {header.categoryGroup.civilServant}
              dataList={this.state.data}
              pageData={this.state.pageData}
              hideExport
              parent= {this}
              tableLoading = {this.state.tableLoading}
            >
              <RowItemCongChuc/>
            </DataTable>
          </div>
          <Dialog
            isOpen={this.state.popupChonDonVi}
            onClose={this.callDialog.bind(this, 'popupChonDonVi', false)}
            title="Chọn đơn vị"
            className="reception-dialog delete-dialog"
          >
            <div className="pt-dialog-body">
              <div className="rows">
                <DropDownTreeSelectOneElement label="Đơn vị" className='col-6 mb0-18 tree-selected' placeholder dataOptions={this.state.DataSelectCoQuanQuanLy} value={this.state.coQuanQuanLyID} onChange={this.onChange.bind(this, 'coQuanQuanLyID')} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId'/>
                <DropDown className="col-6 mb0-18" label="Phòng ban" options={this.state.donViTrucThuocList} keyName="coQuanQuanLyId" valueName="ten" placeholder={{key: '', text: 'Chọn...'}} selectedValue={this.state.donViTrucThuocId} onChange={this.onChange.bind(this, 'donViTrucThuocId')}/>
              </div>
            </div>
            <div className="pt-dialog-footer">
              <div className="rows">
                <Link className="btn-action btn-save" onClick={this.chonDonVi.bind(this)} >
                  <span>Chọn</span>
                </Link>
              </div>
            </div>
          </Dialog>

          <Dialog
            isOpen={this.state.popupAddCategory}
            onClose={this.callDialog.bind(this, 'popupAddCategory', false)}
            title={this.state.addType == 2 ? 'Chỉnh sửa người dùng' : 'Thêm mới người dùng'}
            iconName="add-new"
            className="panel-popup civilServant">
            <ShowIf condition={!this.state.popUpSoNoiVu}>
              <div className="pt-dialog-body">
                <div className="civilservant-wrapper">
                  <form className="form">
                    <div className="container-box">
                      <div className="title">
                        <div className="rows">
                          <div className="col-12">
                            <h3 className="title-civilservant">Thông tin người dùng</h3>
                          </div>
                        </div>
                      </div>
                      <div className="group-box mb5">
                        <div className="items-form">
                          <div className="rows">
                            <Input label="Họ và Tên" className="col-25" bindValidator={this} channel="formTaoDon" require value={this.state.hoVaTen} onChange={this.onChange.bind(this, 'hoVaTen')}/>
                            <Input label="Điện thoại" className="col-25" type="sdt" value={this.state.dienThoai} onChange={this.onChange.bind(this, 'dienThoai')}/>
                            <div className="col-input autocomplete-box">
                              <div className="rows">
                                <div className="radio-gender">
                                  <label className="pt-label">
                                    Giới tính
                                  </label>
                                  <RadioGroup name="gender" onChange={this.onChange.bind(this, 'gender')} selectedValue={this.state.gender}>
                                    <Radio label="Nam"  value="male"   className="pt-large small-title"/>
                                    <Radio label="Nữ"   value="female" className="pt-large small-title"/>
                                  </RadioGroup>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="items-form">
                          <div className="rows">
                            <div className="row pl15 pr15 mb10">

                              <div className={this.state.chonDonViText ? 'col-6' : 'col-25'}>
                                <label className="ip-label">Đơn vị <span className="text-required">&nbsp;*</span></label>
                                { this.state.chonDonViText ? <label className="val-content pr15">{this.state.chonDonViText}</label> : ''}
                                <Link className="btn-green" onClick={this.callDialog.bind(this, 'popupChonDonVi', true)} >
                                  <span>Chọn Đơn vị</span>
                                </Link>
                                {!this.state.validateDonVi ? <div className="pt-form-helper-text">Bạn không được bỏ trống trường này.</div> : ''}
                              </div>
                              <Input label="Chức vụ" className="col-25"  value={this.state.chucVu} onChange={this.onChange.bind(this, 'chucVu')}/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="group-box">
                        <div className='items-form'>
                          <div className="rows">
                            <Input label="Email" className="col-25 mb0-18" bindValidator={this} channel="formTaoDon" require value={this.state.email} onChange={this.onChange.bind(this, 'email')}/>
                            {/* <InputPassword label="Mật khẩu" className="col-25 mb0-18" bindValidator={this} channel="formTaoDon" require={this.state.addType != 2 ? true : false} value={this.state.nguoiDungMatKhau} onChange={this.onChange.bind(this, 'nguoiDungMatKhau')}/> */}
                            {
                              this.state.getVaiTroInfo ? (
                                <div>
                                  <label className="ip-label">Nhóm vai trò <span className="text-required">&nbsp;*</span></label>
                                  <label className="val-content pr15">{this.state.getVaiTroInfo}</label>
                                </div>
                              ) : (
                                <DropDown className="col-25 mb0-18" label="Nhóm vai trò" bindValidator={this} channel="formTaoDon" require options={this.state.DataSelectVaiTrotheoDV} placeholder keyName="vaiTroId" valueName="ten" selectedValue={this.state.vaiTroId} onChange={this.onChange.bind(this, 'vaiTroId')}/>
                              )
                            }
                            {
                              this.state.vaiTroId == 3 ?
                                <div className="col-25" style={{paddingTop: '32px'}}>
                                  <input type="checkbox" id="isCVNL" className="input-cb" name="chuyenVienNhapLieu" checked={this.state.chuyenVienNhapLieu ? true : false} onChange={this.changeCheckbox.bind(this,'chuyenVienNhapLieu')}/>
                                  <label htmlFor="isCVNL">Chuyên viên nhập liệu</label>
                                </div>
                              : ''
                            }
                          </div>
                        </div>
                        {
                          this.state.addType === 2 &&
                          <div className='items-form mt15'>
                            <div className="rows">
                              <DropDown className="col-25" label="Loại thay đổi" options={this.state.DataTrangThaiThayDoi} keyName="giaTri" valueName="ten" placeholder={{key: '', text: 'Chọn...'}} selectedValue={this.state.congChucThayDoi} onChange={this.onChange.bind(this, 'congChucThayDoi')}/>
                              <Input label="Email người dùng cũ" className="col-25 mb0-18" value={this.state.emailNguoiDungCu} onChange={this.onChange.bind(this, 'emailNguoiDungCu')}/>
                              {/* Ẩn liên kết công chức sở nội vụ */}
                              {/* <div className='col-50'>
                                <label className="ip-label">Liên kết Công chức Sở nội vụ</label>
                                { this.state.congChucSoNoiVu ? <label className="val-content pr15" style={{display: 'inline-block'}}>{this.state.congChucSoNoiVu.hoVaTen}</label> : ''}
                                <Link className="btn-green" onClick={this.callDialog.bind(this, 'popUpSoNoiVu', true)} >
                                  <span>Chọn Công chức</span>
                                </Link>
                              </div> */}
                              <TextArea label="Lý do thay đổi" rows={5} value={this.state.lyDoThayDoi} onChange={this.onChange.bind(this, 'lyDoThayDoi')} className='col-100 mb0-18' maxLength={1000}/>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="pt-dialog-footer pb15">
                  <Link onClick={this.callDialog.bind(this, 'popupAddCategory', false)} className="btn-action btn-close" >
                    <span>Đóng</span>
                  </Link>
                  <Link className={this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save"} onClick={this.createCategory.bind(this)} >
                    <span>{this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'}</span>
                  </Link>
              </div>
            </ShowIf>
            <ShowIf condition={this.state.popUpSoNoiVu}>
              <div className="pt-dialog-body">
                <div className="back-foward mt0">
                  <Link onClick={this.callDialog.bind(this, 'popUpSoNoiVu', false)}>Về trang trước</Link>
                </div>
                <div id="list-people-search" className="search-name-container">
                  <form className="items-form" onSubmit={this.timKiemCongChucSNV.bind(this)} action="javascript:void(0)">
                    <div className="rows">
                      <Input label="Từ khóa" className="col-80" value={this.state.tuKhoaSoNV} onChange={this.onChange.bind(this, 'tuKhoaSoNV')}/>
                      <div className="col-2">
                        <label className="seacrh-people">
                          <Button type="submit" className="btn-search" text="Tìm kiếm"/>
                        </label>
                      </div>
                    </div>
                  </form>

                  <DataTable
                    header = {header.popUpCongChucSNV}
                    dataList = {this.state.listCongChucSNV}
                    hideButtonExport={true}
                    pageData= {this.state.pageDataSNV}
                    parent = {this}
                    tableLoading = {this.state.loadingSNV}
                  >
                    <RowItemSearchCongChucSoNoiVu onSelect={this.handleSelectSNV.bind(this)}/>
                  </DataTable>

                </div>
              </div>
            </ShowIf>
          </Dialog>
        </div>
      </MasterLayout>
    );
  }
}

CongChuc.defaultProps = {
  validators: {
    formTaoDon: []
  }
}

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: bindActionCreators(Danhmuc.actions, dispatch)
  };
}
export default connect(bindStateToProps, bindDispatchToProps)(CongChuc);



// WEBPACK FOOTER //
// ./src/components/modules/category/CongChuc.jsx